<div class="account-layout">
  <div class="account-lang">
    <app-language-switcher></app-language-switcher>
  </div>

  <div class="account-content">
    <div class="account-panel">
      <div class="account-brand">
        <img class="account-brand-logo" src="assets/logo/mp_logo_300_300.png" width="48" height="48" alt="" />
        <div class="account-brand-text">
          <h1 class="account-brand-name">{{ 'account.brand' | transloco }}</h1>
        </div>
      </div>

      <div class="account-outlet">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
